
import $ from 'jquery';
import Selection, {SelectionEvent} from '../../../model/model-selection';
import Map from '../../map/map';
import commentModalContent from '../comment-modal/commentModalContent.html';
import FeatureLayers from '../contract-features/contract-features-featureLayers';
import {Destination} from "../../../integration/representation/contract";
import {ICompileService, IQService, IScope} from "angular";
import nvdbapi from "../../../integration/nvdbapi/nvdbapi";
import datacatalog from "../../../integration/datacatalog/datacatalog-services";
import contractService from "../../../service/contract/contract-services";
import server from "../../../integration/server/server-services";
import {CompletenessItem} from "../../../integration/representation/feature-type";
import * as angular from "angular";

export interface Dispatcher {
    reactFeaturesKey: string;
    reactFeaturesEditorKey: string;
    featureComment: string;
    featureTypeComment: string;
    featureTypeLock: string;
    toggleFeature: (featureId: string) => void;
    featureTypeSelection: undefined;
    listeners: {
        reactFeatures: Function;
        reactFeaturesEditor: Function;
        featureComment: Function;
        featureTypeComment: Function;
    }
    addListener: (key: string, listener: Function) => void;
    removeListener: (key: string) => void;
    signalSelectonHasChanged: () => void;
    featureCommentClicked: (featureType: any, feature: any, destination: Destination) => void;
    featureTypeCommentClicked: (featureTypeId: number, destination: Destination) => void;
}

interface FeaturetypeModalControllerScope extends IScope {
    contractid: string;
    dispatcher: Dispatcher;
}

export default function FeaturetypeModalController($scope: FeaturetypeModalControllerScope, $compile: ICompileService,
                                                   $uibModal: angular.ui.bootstrap.IModalService,
                                                   $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,
                                                   $q: IQService, featuretype: CompletenessItem,
                                                   destination: Destination, nvdbapi: nvdbapi, datacatalog: datacatalog,
                                                   contract: contractService, server: server, onCommentCallbacks: Function[]) {
    const vm = this;
    vm.featuretype = featuretype;
    vm.destination = destination;

    $scope.contractid = contract.contractId;
    (window as any).datastore = {
        featureTypes: [],
        contract
    };
    const dispatcher: Dispatcher = {
        reactFeaturesKey : 'reactFeatures',
        reactFeaturesEditorKey : 'reactFeaturesEditor',
        featureComment : 'featureComment',
        featureTypeComment : 'featureTypeComment',
        featureTypeLock : 'featureTypeLock',
        toggleFeature: undefined,
        featureTypeSelection: undefined,
        listeners: {
            reactFeatures: undefined,
            reactFeaturesEditor: undefined,
            featureComment: undefined,
            featureTypeComment: undefined
        },
        addListener(key: string, listener: Function) {
            this.listeners[key] = listener;
        },
        removeListener(key) {
            delete this.listeners[key];
        },
        signalSelectonHasChanged() {
            if (dispatcher.listeners.reactFeatures) {
                dispatcher.listeners.reactFeatures();
            }
            if (dispatcher.listeners.reactFeaturesEditor) {
                dispatcher.listeners.reactFeaturesEditor();
            }
            $('#feature-data').find('.cssloader').addClass('hidden');
        },
        featureCommentClicked(featureType, feature, destination) {
            dispatcher.listeners.featureComment(featureType, feature, destination);
        },
        featureTypeCommentClicked(featureTypeId, destination) {
            dispatcher.listeners.featureTypeComment(featureTypeId, destination);
        }
    };

    dispatcher.addListener(dispatcher.featureTypeComment, function(featureTypeId: number, destination: Destination) {
        $uibModal.open({
            animation: true,
            template: commentModalContent,
            controller: 'FeatureTypeCommentController',
            controllerAs: 'commentCtrl',
            resolve: {
                featureTypeId(){
                    return featureTypeId;
                },
                destination(){
                    return destination;
                },
                dispatcher(){
                    return dispatcher;
                },
                onCommentCallbacks() {
                    return onCommentCallbacks;
                }
            }
        }).result.catch((resp: string) => {
            if (['cancel', 'backdrop click', 'escape key press'].indexOf(resp) === -1) throw resp;
        });
    });

    dispatcher.addListener(dispatcher.featureComment, function(featureType: any, feature: any, destination: Destination) {
        $uibModal.open({
            animation: true,
            template: commentModalContent,
            controller: 'FeatureCommentController',
            controllerAs: 'commentCtrl',
            resolve: {
                featureType(){
                    return featureType;
                },
                feature(){
                    return feature;
                },
                destination(){
                    return destination;
                },
                dispatcher(){
                    return dispatcher;
                },
                selectedFeatures(): any[]{
                    return [];
                },
                onCommentCallbacks() {
                    return onCommentCallbacks;
                }
            }
        }).result.catch((resp: string) => {
            if (['cancel', 'backdrop click', 'escape key press'].indexOf(resp) === -1) throw resp;
        });

    });

    $scope.dispatcher = dispatcher;

    const reactFeatureToggleCallback = function(featureTypeId: number){
        (window as any).datastore.featureTypes.filter(function(type: any){
            return type.isSelected;
        })
            .forEach(function(featureType: any){
                featureType.features.filter(function(feature: any){
                    return feature.id == featureTypeId;
                })
                    .forEach(function(f: any){
                        f.isSelected = !f.isSelected;
                    });
            });
        dispatcher.signalSelectonHasChanged();
    };

    (contract as any).reactFeatureToggleCallback = reactFeatureToggleCallback;

    $scope.$on('modal.closing', function(){
        delete (window as any).datastore;
        delete (contract as any).reactFeatureToggeCallback;
    });

    $uibModalInstance.rendered.then(function(){
        const map = new Map(document.getElementById('featuremap'));
        // @ts-ignore
        const featureLayers = new FeatureLayers($q, map.getLeafletMap(), datacatalog, onFeatureClick, isSelectedFeature);

        const selectedFeatureIds = new Selection();

        vm.showQualityParams = false;
        vm.featureTypeSelection = new Selection(onFeatureTypeSelectionChange);
        vm.contract = contract;

        vm.featureTypeIcon = featureTypeIcon;
        vm.isSelectedFeature = isSelectedFeature;
        vm.toggleFeature = toggleFeature;

        dispatcher.toggleFeature = toggleFeature;
        dispatcher.featureTypeSelection = vm.featureTypeSelection;

        const selectedId = destination === 'NVDB' ? 'NVDB-' + featuretype.nvdbFeatureTypeId : 'FKB-' + featuretype.fkbFeatureTypeId;
        const featuresFromServer = destination === 'NVDB' ? server.getFeaturesViewModel($scope.contractid) : server.getFkbFeaturesViewModel($scope.contractid);
        featuresFromServer.then(function( data ) {
            (window as any).datastore = data;
            (window as any).datastore.contract = contract;
            (window as any).datastore.featureTypes.forEach(function(featureType: any){
                featureType.isSelected = destination + '-' + featureType.id == selectedId;
            });

            vm.featureTypeSelection.toggleSelected(selectedId, false);
            onFeatureClick(selectedId);
            setupColumnHeaderPopover();
            map.leafletMap.invalidateSize();
        });

        vm.ok = function() {
            $uibModalInstance.close();
            map.leafletMap.remove();
        };

        function isSelectedFeature(feature: any){
            if (feature === undefined){
                return false;
            } else {
                return selectedFeatureIds.isSelected(feature.id);
            }
        }

        // click feature on map
        function onFeatureClick(featureId: string) {
            (contract as any).reactFeatureToggleCallback(featureId);
            toggleFeature(featureId);
        }

        function toggleFeature(featureId: string) {
            selectedFeatureIds.toggleSelected(featureId, true);
            featureLayers.setSelected(featureId, selectedFeatureIds.isSelected(featureId));
        }

        function onFeatureTypeSelectionChange(event: SelectionEvent<string>) {
            const selected = event.newSelection[0];
            if (selected){
                const split = selected.split('-');
                const destination = split[0];
                const typeId = parseInt(split[1]);

                const featureList = destination === 'NVDB' ? contract.featureList : contract.fkbFeatureList;
                const newFeatures = featureList.getFeaturesByType(typeId);
                featureLayers.addFeatures(newFeatures);
                vm.selectedFeatures = newFeatures;
            }
        }

        function featureTypeIcon(typeId: number) {
            if (contract.featureList.issuesForType(typeId).errors[0] ) return 'glyphicon-fire icon-color-error';
            if (contract.featureList.issuesForType(typeId).warnings[0]) return 'glyphicon-fire icon-color-warning';
            return 'glyphicon-ok';
        }

        function setupColumnHeaderPopover() {
            const $features = $('#feature-data');
            ($features as any).popover({
                selector: '.issuepopover,.pophelp',
                placement: 'top',
                trigger: 'hover',
                container: 'body',
                html: true,
                content(){
                    const attr = ($(this) as any).attr('data-value');
                    return '<pre>' + attr + '</pre>';
                }
            });
        }
    });

}
FeaturetypeModalController.$inject = ['$scope', '$compile', '$uibModal', '$uibModalInstance', '$q', 'featuretype', 'destination', 'nvdbapi', 'datacatalog', 'contract', 'server', 'onCommentCallbacks'];
